import styled from "@emotion/styled";

export const AgreementModalContainer = styled.div`
    width: 61em;
    gap: 1rem;
    color: #000000;
    position: relative;
    padding: 2rem 1.5rem;
    border-radius: 0.75rem;
    background-color: #ffffff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    @media (min-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 1024px) {
        width:100%
    }
    font-family: "Helvetica", Arial, sans-serif;
`;

export const AgreementModalContentContainer = styled.div`
    overflow-y: auto;
    max-height: 35em;
    @media (max-width: 1023px) {
       padding-bottom:10%;
    }
`;

export const AgreementModalTitle = styled.h1`
    font-size: 22px;
    border-bottom: 2px solid #163b5d;
    padding: 5px;
    text-align: center;
    width: fit-content;
    margin: auto;
    margin-top: 5px;
    margin-bottom: 5px;
`;

export const AgreementModalText = styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 1.5;
    overflow-wrap: anywhere;
`;

export const ButtonContainer = styled.div`
    display: flex;
    -webkit-box-pack: center;
    justify-content: start;
    gap: 15px;
    width: 100%;
    padding: 10px;
`;
export const AgreeButton = styled.button`
    background-color: rgb(22, 59, 93);
    border-radius: 0.8em;
    font-size: 0.938rem;
    font-weight: 500;
    padding:0.6em 1.3em;
    color: white;
    border: none;
`;

export const PrintableArea = styled.div`
    padding: 0px 15px;
`;

export const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 20px 0px;
    font-family: Helvetica, Arial, sans-serif;
`;

export const AgreementModalSubtitle = styled.h2`
    font-size: 20px;
    margin-top: 5px;
`;
export const AgreementModalLink = styled.a`
    font-size: 15px;
    color: #0000ee;
    margin-bottom: 20px;
`;

export const AgreementModalUnorderList = styled.ul`
    line-height: 1.5;
`;

export const AgreementModalList = styled.li`
    font-size: 15px;
    line-height: 1.5;
    font-weight: 400;
`;
